<!-- 应收报表 -->
<template>
    <div class="container containerBox">
        <!-- 头部筛选区 -->
        <div class="handleForm">
            <el-form :inline="true" label-width="100px" :model="handleForm" class="demo-form-inline">
                <el-form-item label="住户名称">
                    <el-input v-model="handleForm.name" placeholder="请输入住户名称"></el-input>
                </el-form-item>
                <el-form-item label="楼宇选择">
                    <cmp-build-select 
                    :buildRoom="buildRoom"
                    changeOnSelect
                    @listenBuildResult="listenBuildResult"></cmp-build-select>
                </el-form-item>
                <el-form-item label="选择时间段">
                    <el-date-picker
                        v-model="handleForm.date"
                        type="daterange"
                        @change="handleDateChange"
                        range-separator="至"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <div class="fr">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <!-- <el-button type="primary" @click="handleExport">导出</el-button> -->
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :span-method="objectSpanMethod"
            :height="maxHeight"
            border
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>

    </div>
</template>

<script>
import Service from '@/api/Service'

import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import LbTable from '@/components/lb-table/lb-table'

import { getMaxHeigth, FormatDate, funFmtDevType, fmtHouseInfo } from '@/utils/utils'

const nowDay = FormatDate("yyyy-MM-dd");
export default {
    name: 'receivablestatement',
    data () {
        return {
            // 搜索参数
            handleForm: {
                from: nowDay,
                to: nowDay,
                oid: '0',
                household_id: '',
                date: [],
				is_house:false,
            },
			pay_status:1,
            // 选择房间组件
            buildRoom: {},

            tableData: {
                column: [
                    // {
                    //     type: 'expand',
                    //     render: (h, props) => {
                    //         return  (
                    //             <div>
                    //                 <el-alert
                    //                     title="房间表计用量明细"
                    //                     type="success"
                    //                     closable={false}>
                    //                 </el-alert>
                    //                 <el-table
                    //                     data={ props.row.terminal_cost_list }
                    //                     stripe
                    //                     style="width: 100%">
                    //                     <el-table-column
                    //                         prop="device_model"
                    //                         label="表计型号">
                    //                     </el-table-column>
                    //                     <el-table-column
                    //                         prop="devtype"
                    //                         label="类型"
                    //                         formatter={this.fmtDevType}>
                    //                     </el-table-column>
                    //                     <el-table-column
                    //                         prop="terminalserial"
                    //                         label="序列号">
                    //                     </el-table-column>
                    //                     <el-table-column
                    //                         prop="terminal_usage"
                    //                         label="用量"
                    //                         formatter={this.formatterTofix3}>
                    //                     </el-table-column>
                    //                     <el-table-column
                    //                         prop="terminal_cost"
                    //                         label="费用"
                    //                         formatter={this.formatterTofix4}>
                    //                     </el-table-column>
                    //                 </el-table>
                    //             </div>
                    //         )
                    //     }
                    // },
                    {
                        prop: 'household_name',
                        label: "业主名称",
                    },
                    {
                        prop: 'house_name',
                        label: '房间号',
                    },
                    {
                        prop: 'house_area',
                        label: '房屋面积',
                    },
                    {
                        prop: 'house_basic_cost',
                        label: '房间基础花费',
                    },
                    {
                        prop: 'house_rate',
                        label: '房间面积单价',
                    },
                    {
                        prop: 'is_paied',
                        label: '缴费状态',
						formatter: (row, column, cellValue) => {
						    return row.is_paied?"已缴费":"未缴费"
						}
                    },
                    {
                        prop: 'last_settlement_time',
                        label: '账单开始时间',
                    },
                    {
                        prop: 'settlement_time',
                        label: '账单结束时间',
                    },
                    {
                        prop: 'terminal_cost',
                        label: '表计花费',
                    },
					{
					    prop: 'real_cost',
					    label: '实际花费',
					},
					{
					    prop: 'sum_cost',
					    label: '总花费',
					},
					{
					    label: '操作',
					    width: '180px',
					    render: (h, scope) => {
					    return (
					        <div>
					        <el-button
					            size="mini"
					            type="primary"
					            onClick={ () => { this.getcount(scope.row) } }>缴费</el-button>
					        </div>
					    )
					    }					
					}
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,

            spanCom: {},
        };
    },
    components: { LbTable, CmpBuildSelect },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    created() {
        this.getData();
    },
    methods: {
        // 获取数据
        async getData() {
            let params = {}
            params.ids = JSON.stringify([{oid: this.handleForm.oid}])
            params.household_name = this.handleForm.name
            params.from = this.handleForm.from;
            params.to = this.handleForm.to;
            params.is_house =this.handleForm.is_house;
            params.pay_status = this.pay_status;
            params.page_num = this.page_num;
            params.page_sum = this.page_sum;

            // let res = await Service.getHouseholdcostbypid(params);
			let res = await Service.getHouseBill(params)
			if(res){
				this.tableData.data =res.list || []
				this.total = res.total
			}
            // if(res) {
            //     let newArr = [];
            //     if(res.list.length>0) {
            //         res.list.map(v=>{
            //             let L =  v.house_cost_list.length;
            //             v.house_cost_list.map((v1, i)=>{
            //                 if(i === 0) {
            //                     this.spanCom[v1.assigned_house_id] = L
            //                 }
            //                 v1.household_cost = v.household_cost.toFixed(2)
            //                 newArr.push(v1)
            //             })
            //         })
            //     }
            //     this.tableData.data = newArr
            //     this.total = res.total
            // }
        },
        // 查询
        onSubmit() {
			if(this.handleForm.oid != ''){
				this.getData();
			}else{
				this.$message({
					message: '请选择建筑！！',
					type: 'warning'
				});
				return
			}
        },
		async getcount(row){
			if(row.is_paied){
				this.$message({
					message: '该账单已缴费！',
					type: 'success'
				});
				return
			}
			let res = await Service.PayFor({bill_house_id:row.oid})
			if(res){
				this.$message({
					message: '缴费成功',
					type: 'success'
				});
				this.getData();
			}
		},
        // 最后一级房间确认信息
        listenBuildResult(data) {
			if(data.householdid === undefined) {
			    // 建筑
			    this.handleForm.is_house = false
			}else{
			    // 房间
			    this.handleForm.is_house = true
			}
            this.handleForm.oid = data.oid + '';
        },
        handleDateChange(val) {
            if(val) {
                this.handleForm.from = val[0]
                this.handleForm.to = val[1]
            }else{
                this.handleForm.from = nowDay
                this.handleForm.to = nowDay
            }
        },
        //   获取数据
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
        objectSpanMethod ({ row, column, rowIndex }) {
            if(column.property === 'householdname') {
                if(rowIndex != 1){
                    let rowspan = this.spanCom[row.assigned_house_id]
                    return {
                        rowspan: rowspan,
                        colspan: 1
                    }
                }else{
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
            if (column.property === 'household_cost') {
                if(rowIndex != 9){
                    let rowspan = this.spanCom[row.assigned_house_id]
                    return {
                        rowspan: rowspan,
                        colspan: 1
                    }
                }else{
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        },
		fmtOnlineStatus(){
			
		},
        // 格式化表计类型
        // fmtDevType(row) {
        //     return funFmtDevType(row.devtype);
        // },
        // // 安装位置
        // fmtHouse(row){
        //     return fmtHouseInfo(row.housename, row.moduleidlist);
        // },
        // formatterTofix3(row) {
        //     return row.terminal_usage.toFixed(2);
        // },
        // formatterTofix4(row) {
        //     return row.terminal_cost.toFixed(2);
        // },
        // formatterTofix1(row) {
        //     return row.terminal_fin_cost.toFixed(2);
        // },
        // formatterTofix2(row) {
        //     return row.terminal_sum_cost.toFixed(2);
        // },
        // 导出
        handleExport() {

        },
    }
}

</script>
<style lang='css' scoped>
</style>